import { useAuth } from 'context/AuthContext'
import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { roles } from 'router/index'
import * as S from './styles'

const SideBar = ({ mobile }) => {
  const { user } = useAuth()
  const role = user?.role
  const { pathname } = useLocation()
  const styles = {
    color: 'var(--color-secondary)',
  }

  return (
    <S.LinksContainer mobile={mobile}>
      <S.Links>
        {gatherLinks(roles[role].paths).map((p) => {
          const path = p.path.split('/:')[0]
          return (
            <li key={p.path}>
              <NavLink
                style={path !== pathname ? styles : {}}
                to={path}
              >
                {p.name}
              </NavLink>
            </li>
          )
        })}
      </S.Links>
    </S.LinksContainer>
  )
}

export const gatherLinks = (paths, gatheredPath = '') => {
  const allPaths = []
  paths.forEach((p) => {
    const completePath = `${gatheredPath}${p.path ? `/${p.path}` : ''}`
    if (p.paths) allPaths.push(...gatherLinks(p.paths, completePath))
    else if (p.name) allPaths.push({ name: p.name, path: completePath })
  })
  return allPaths
}

export default SideBar
